import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";

/**
 * Service for managing A/B Test Results (F-026).
 * Provides CRUD operations for test result snapshots.
 */
@Injectable({
    providedIn: 'root'
})
export class ABTestResultService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/abTestResults')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-chart-bar';
    }
}
